import React, { useEffect } from 'react'
import '../App.css'
import '../styles/MainContainer.css'
import './aboutus.css'
import 'react-datepicker/dist/react-datepicker.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import TopBar from '../components/TopBar.jsx'
import Footer from '../components/Footer.jsx'
import faq from '../icons/faq.webp'

function Faq() {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, [])

  return (
    <div>
      <div className="GlobalContainer relative overflow-hidden">
        <div style={{ zIndex: 1 }}>
          <TopBar />

          {/* Hero Section */}
          <div className="mt-[120px] sm:mt-0 p-6 md:p-20 flex flex-col-reverse md:flex-row items-center justify-between gap-8 text-white">
            <div
              className="max-w-[600px] text-center md:text-left"
              data-aos="fade-up"
            >
              <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4">
                launch safe. <br className="hidden md:inline" />
                launch fair.
              </h1>
              <p className="text-lg md:text-xl text-gray-300 mb-6">
                every token on hotcurves.fun is a fair launch. no presale. no
                team allocation. just vibes.
              </p>
              <a
                href="https://docs.hotkeyswap.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8] hover:bg-[#2a2d36] hover:border-[#a135bb] text-sm md:text-base transition-all hk-buzz"
              >
                explore our docs
              </a>
            </div>
            <img
              src={faq}
              alt="Mascot"
              className="w-[250px] md:w-[400px]"
              data-aos="fade-left"
            />
          </div>

          {/* Feature Cards */}
          <div
            className="px-6 md:px-20 mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 text-white"
            data-aos="fade-up"
          >
            <div className="group rounded-md border-[0.5px] border-[#2a2d36] bg-[#171a21] p-6 text-center shadow-[0_0_8px_rgba(245,0,255,0.08)] hover:shadow-[0_0_12px_rgba(245,0,255,0.12)] hover:border-[#383c46] transition-all">
              <h3 className="text-xl font-semibold mb-2">no presale</h3>
              <p className="text-sm text-[#f8ffe8]/75">
                everyone enters at the same time. no early whales.
              </p>
            </div>
            <div className="group rounded-md border-[0.5px] border-[#2a2d36] bg-[#171a21] p-6 text-center shadow-[0_0_8px_rgba(245,0,255,0.08)] hover:shadow-[0_0_12px_rgba(245,0,255,0.12)] hover:border-[#383c46] transition-all">
              <h3 className="text-xl font-semibold mb-2">rug-free</h3>
              <p className="text-sm text-[#f8ffe8]/75">
                liquidity is locked and contracts are renounced.
              </p>
            </div>
            <div className="group rounded-md border-[0.5px] border-[#2a2d36] bg-[#171a21] p-6 text-center shadow-[0_0_8px_rgba(245,0,255,0.08)] hover:shadow-[0_0_12px_rgba(245,0,255,0.12)] hover:border-[#383c46] transition-all">
              <h3 className="text-xl font-semibold mb-2">instant launch</h3>
              <p className="text-sm text-[#f8ffe8]/75">
                deploy your token in under 60 seconds.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-8 mb-6 text-center text-sm text-[#f8ffe8]/60 max-w-3xl mx-auto italic px-6">
            trading crypto is risky. Do your own research. hotcurves.fun isn’t
            responsible for any financial losses. always stay safe out there.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Faq
